<!--
 * @Author: lbh
 * @Date: 2021-03-25 14:55:37
 * @LastEditors: lbh
 * @LastEditTime: 2021-10-12 10:01:23
 * @Description: file content
-->
<template>
  <!-- https://hktest.ricepon.com:64377/member-web/advert_item_list.html?advertId=341 -->
  <div class="content self_c">
    <headNav
      :back="true"
      color="#56AC9A"
    />
    <div class="self_b">
      <iframe
        :style="'min-height:' + window_.wh + 'px;'"
        :src="`${origin}/advert_item_list.html?advertId=${id}`"
      ></iframe>
    </div>
  </div>
</template>

<script>
import headNav from '@/components/headNav';
import util from '@/js/util.js';
import myfn from "@/js/util";

export default {
  data () {
    return {
      window_: {
        wh: 0
      },
      id: '',
      origin: ''
    };
  },
  created () {
    util.selfSetIcon() // 設置logo
    util.getBrand(this)
    let origin = location.origin;
    if (origin.indexOf('192.168') > -1 || origin.indexOf('localhost') > -1) {
      origin = "https://hktest.ricepon.com:64377";
    }
    this.origin = origin;
    let J = util.getWindowInner(),
      w = J.w, h = J.h;
    this.window_.wh = h - 46;
    let encId = myfn.getQueryParams(this.$route.params)
    var id = encId[1];
    // var id = 780;
    // console.log(111111,myfn.getQueryParams(this));

    var src = '' + id;
    this.id = id;
  },
  components: {
    headNav
  }
};
</script>

<style scoped>
iframe {
  width: 100%;
  border: none;
  height: 100% !important;
}

.pc_content iframe {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/view/brand/ad.vue